import { Component, computed, input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { KENDO_DROPDOWNLIST } from "@progress/kendo-angular-dropdowns";
import { KENDO_NUMERICTEXTBOX, KENDO_TEXTBOX } from "@progress/kendo-angular-inputs";
import { ChangedFieldDirective } from "../../changed-field.directive";
import { FUEL_QUANTITIES, FuelFields, FuelGroup, MaxTank } from "./fuel-row";

/** One line of fuel: its name, the arrival, planned, refuel and total quantities, and where it was refuelled. */
@Component({
    selector: "app-fuel-row",
    imports: [ChangedFieldDirective, ReactiveFormsModule, TranslatePipe, KENDO_TEXTBOX, KENDO_NUMERICTEXTBOX, KENDO_DROPDOWNLIST],
    templateUrl: "./fuel-row.component.html",
    styleUrl: "../../edit-fields.scss",
})
export class FuelRowComponent {
    readonly group = input.required<FuelGroup>();
    readonly fields = input.required<FuelFields>();
    /** The units the organization logs fuel in. */
    readonly units = input.required<string[]>();
    /** The tanks' capacity, when the organization checks the fuel against it. */
    readonly maxTank = input<MaxTank>(null);

    /** Whether the refuel quantity is required (a refuel before the first flight). */
    readonly refuelRequired = input(false);

    readonly quantities = FUEL_QUANTITIES;
    readonly maxTankText = computed(() => {
        const max = this.maxTank();
        return max ? `${max.value} ${max.unit ?? ""}`.trim() : "";
    });
}
